import React, { useState } from "react";
import PlantillaVerificacionService from "../../services/ListaVerificacion/PlantillaVerificacionService";
import { IPostCrearPlantillaVerificacion } from "../../Interfaces/IPlantillaVerificacion";
import { IResponsePost } from "../../Interfaces/base/IResponse";

export const useCrearPlantillaVerificacion = (onDismiss: ()=>void) => {
  const [response, setResponse] = useState<IResponsePost>(null!);
  const [loading, setLoading] = useState(false);

  const postCrearPlantillaVericacion = (
    data: IPostCrearPlantillaVerificacion
  ) => {
    setLoading(true);
    PlantillaVerificacionService.PostCrearPlantillaVerificacion(data).then(
      (res) => {
        if (res.status === 200) {
          setResponse(res.data);
          setTimeout(() => {
            onDismiss()
          }, 2400);
          setLoading(false);
        } else {
          setLoading(false);
           setTimeout(() => {
            onDismiss()
          }, 2400);
        }
      }
    );
  };

  return { postCrearPlantillaVericacion, response, loading };
};
